import { mergeStyles } from '@fluentui/style-utilities';

export const defaultIconClass = mergeStyles({
  display: 'flex',
});

export const getIconClass = (colorString = 'white') => mergeStyles(defaultIconClass, {
  selectors: {
    svg: {
      fill: colorString,
    },
  },
});
